import { UserCredentialsModel } from "../models/userCredentials";
import { ResultRequestModel } from "../models/resultRequest.model";
import { RecoveryPasswordModel } from "../models/recoveryPassword.model";
import { HttpService } from "./http.service";

const basePath = "/Auth";
const request = HttpService.handleRequest();

export const AuthService = {
  login,
  loginBAS,
  forgotPassword,
  refreshToken,
  recoveryPassword,
  changeLocale
};

async function login(data: UserCredentialsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/Login`, data);
}

async function loginBAS(token: string): Promise<ResultRequestModel> {
  return request.post(`${basePath}/LoginBAS`, {token});
}

async function forgotPassword(email: string): Promise<ResultRequestModel> {
  return request.post(`${basePath}/ForgotPassword`, {
    login: email
  });
}

async function refreshToken(data: string): Promise<ResultRequestModel> {
  return request.post(`${basePath}/ForgotPassword`, data);
}

async function recoveryPassword(data: RecoveryPasswordModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/RecoveryPassword`, data);
}

async function changeLocale(localeId: number): Promise<ResultRequestModel> {
  return request.post(`${basePath}/ChangeLocale`, { localeId });
}

export default AuthService;
